export const BASE_URL = 'https://sdk-test.gainfedpay.com'